import { isString } from 'remeda'
import { z } from 'zod'
import { Base64 } from 'js-base64'
import Debug from 'debug'
const debug = Debug('jotta:grpc:CommentRefUrlSchema')

export const CommentRefUrlSchema = z.preprocess(
  arg => {
    try {
      if (isString(arg)) {
        return JSON.parse(Base64.decode(arg))
      }
      // if (arg instanceof URL && arg.searchParams.has('comment')) {
      //   return Base64.decode(String(arg.searchParams.get('comment')))
      // }
      // if (arg instanceof URLSearchParams && arg.has('comment')) {
      //   return Base64.decode(String(arg.get('comment')))
      // }
    } catch (error) {
      debug('Failed to parse string', error)
    }
    return arg
  },
  z.object({
    id: z.string().uuid(),
  }),
)
